import { useMutation, useQueryClient } from "@tanstack/react-query";

import { listsQueryKeys } from "app/pages/sales-intelligence/modules/lists/query/key-factory/factory";
import { opportunityListQueryKeyFactory } from "app/pages/sales-intelligence/pages/opportunity-list/query/queryKeyFactory";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

export const useDeleteTagMutation = (listId: string) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (tagId: string) => {
            return salesApiService.listColumns.deleteTag(listId, tagId);
        },
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: listsQueryKeys.getTags(listId) });
            void queryClient.invalidateQueries({
                queryKey: opportunityListQueryKeyFactory.leadsTableData(listId, "companies"),
            });
        },
    });
};
